import { Injectable } from "@angular/core";
import { BaseUserService } from "@smarterplan/ngx-smarterplan-core";
import { Amplify, Hub, Auth } from "aws-amplify";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ConnectionService {
    private _isAuthenticated = false;

    public isConfigured = false;

    public get isAuthenticated() {
        return this._isAuthenticated;
    }

    public set isAuthenticated(value) {
        this._isAuthenticated = value;
    }

    authenticatedChange = new Subject<boolean>();

    hubListener = (data) => {
        switch (data.payload.event) {
            case "signIn":
                // console.log("user signed in");
                this.isAuthenticated = true;
                this.configureAuthMode();
                break;
            case "signUp":
                break;
            case "signOut":
                // console.log("user signed out");
                this.isAuthenticated = false;
                this.configureAuthMode();
                break;
            case "signIn_failure":
                // console.log("user sign in failed");
                this.isAuthenticated = false;
                this.configureAuthMode();
                break;
            case "configured":
                // console.log("the Auth module is configured");
                break;
            case "tokenRefresh":
                // console.log("connection service token refresh");
                this.isAuthenticated = true;
                // this.configureAuthMode();
                break;
            default:
                console.log(data.payload.event);
        }
    };

    constructor(private userService: BaseUserService) {
        Hub.listen("auth", this.hubListener);
    }

    async configureAuthMode() {
        // console.log("about to configure auth mode", this.isAuthenticated);
        if (this.isAuthenticated) {
            this.authenticatedChange.next(true);
            Amplify.configure({
                aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
            });
            await this.userService.checkConnectedAWSUser();
        } else {
            this.authenticatedChange.next(false);
            Amplify.configure({
                aws_appsync_authenticationType: "AWS_IAM",
            });
        }
        this.isConfigured = true;
    }
}
